<template>
  <div id="annonce-create-step-right-part" class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom">
    <div id="annonce-create-step-right-part-inside" class="col-12 pl-0 pr-0 mb-1" v-if="!isLoading">
      <transition-group name="listCustomTransition" tag="div" class="item-container-annonce">
        <div class="item-annonce" v-for="(annonce, index) in annonces" :key="index+'-annonce'" @click="editAnnonce($event, index)">
          <div class="d-flex  justify-content-between">
            <p>{{annonce.brand.name + " - " + annonce.model.name}}</p>
            <i class="ph ph-custom ph-trash main-red-color cursor-pointer editAnnonce-forbidden" @click="removeAnnonce(index)"></i>
          </div>
          <div  v-if="annonce.vehicleFiles.length>0">
            <img class="w-100 rounded" :src="annonce.vehicleFiles[0].url || getFileUrl(annonce.vehicleFiles[0].fileUrl)" alt="Annonce Image">
          </div>
          <div  v-else>
            <img class=" w-100 rounded no-result-img" :src="require(`@/assets/images/b122/PLACEHOLDER.png`)" alt="no result">
          </div>
          <div class="d-flex justify-content-between mt-2">
            <div class="d-flex align-items-center">
              <i class="ph ph-custom ph-scan main-color cursor-pointer"></i>
              <div class="ml-2">{{formatAnnonceInfo(annonce)}}</div>
            </div>
            <div>
              <i v-for="index in 5" :class="(index <= annonce.additionnalRewardLevel.value ? 'ph-star-fill' : 'ph-star') + ' main-color'"></i>
            </div>
          </div>
          <div class="d-flex align-items-center mt-2">
            <i class="ph ph-custom ph-map-pin main-color cursor-pointer"></i>
            <div class="ml-2">{{annonce.address.value}}</div>
          </div>
          <div class="d-flex align-items-center mt-2">
            <div :class="'ml-2 ' + (annonce.isComplete ? 'main-green-color' : 'main-red-color')">{{annonce.isComplete ? $t('create.annonce.summary.complete') : $t('create.annonce.summary.partial')}}</div>
          </div>
        </div>
      </transition-group>

      <div class="small-text" v-if="annoncesSaved.length>0" :class="{'mt-3' : this.annonces.length>0}">
        {{ $t('annonce.Recap.annonces.saved') }}
      </div>
      <div class="item-annonce" v-for="(annonce, index) in annoncesSaved" :key="index">
        <div class="d-flex  justify-content-between">
          <p>{{annonce.brand.name + " - " + annonce.model.name}}</p>
          <i class="ph ph-custom ph-trash main-red-color cursor-pointer"></i>
        </div>
        <div  v-if="annonce.vehicleFiles.length>0">
          <img class="w-100 rounded" :src="annonce.vehicleFiles[0].url || getFileUrl(annonce.vehicleFiles[0].fileUrl)" alt="Annonce Image">
        </div>
        <div  v-else>
          <img class=" w-100 rounded no-result-img" :src="require(`@/assets/images/b122/PLACEHOLDER.png`)" alt="no result">
        </div>
        <div class="d-flex justify-content-between mt-2">
          <div class="d-flex align-items-center mr-1">
            <i class="ph ph-custom ph-scan main-color cursor-pointer"></i>
            <div class="ml-2">{{formatAnnonceInfo(annonce)}}</div>
          </div>
          <div>
            <i v-for="index in 5" :class="(index <= annonce.additionnalRewardLevel ? 'ph-star-fill' : 'ph-star') + ' main-color'"></i>
          </div>
        </div>
        <div class="d-flex align-items-center mt-2">
          <i class="ph ph-custom ph-map-pin main-color cursor-pointer"></i>
          <div class="ml-2">{{annonce.address.value}}</div>
        </div>
      </div>

      <div class="d-flex justify-content-center" :class="{'mt-3' : (this.annonces.length + this.annoncesSaved.length)>0, 'pb-4' : (this.annonces.length + this.annoncesSaved.length)>1}">
        <i class="ph ph-custom ph-plus-circle custom-plus main-color cursor-pointer" @click="$bvModal.show('recap-add-annonce')"/>
      </div>
    </div>
    <recap-add-annonce @addNewAnnonce="addNewAnnonce" @openBrouillonModal="openBrouillonModal"></recap-add-annonce>
    <recap-add-brouillon-annonce-modal :annoncesIds="annoncesIds" @addDraft="addDraft" @openRecapAddAnnonceModal="backToAddAnnonce"></recap-add-brouillon-annonce-modal>
  </div>
</template>

<script>
import api from "../../../services/api";
import RecapAddAnnonce from "../../../components/annonce/RecapAddAnnonce";
import RecapAddBrouillonAnnonceModal from "../../../components/annonce/RecapAddBrouillonAnnonceModal";

export default {
  name: "AnnonceCreateRecapStep",

  components:{
    RecapAddAnnonce,
    RecapAddBrouillonAnnonceModal
  },

  emits: ["removeAnnonce","addNewAnnonce","editAnnonce","addDraft"],

  props: {
    annonces: {
      required: true,
      type: Array
    },
    annoncesSaved: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      isLoading:false,
    };
  },

  async mounted() {
    this.isLoading = true
    await Promise.all(this.annonces.map(async (annonce) => {
      annonce.model.name = await this.getModelNameById(annonce.model.value);
      annonce.brand.name = await this.getBrandNameById(annonce.brand.value);
    }));
    this.isLoading = false
  },

  computed: {
    annoncesIds() {
      return this.annonces.filter((annonce) => annonce.id !== null && annonce.id > 0).map((annonce) => ( annonce.id ))
    }
  },

  methods: {
    async getModelNameById(modelId) {
      try {
        const response = await api.get(`/model/getNameById/${modelId}`);
        return response.data.name;
      } catch (error) {
        console.error("Error fetching model name", error);
        this.isLoading = false
        return "Unknown Model";
      }
    },

    async getBrandNameById(brandId) {
      try {
        const response = await api.get(`/brand/getNameById/${brandId}`);
        return response.data.name;
      } catch (error) {
        console.error("Error fetching brand name", error);
        this.isLoading = false
        return "Unknown Brand";
      }
    },

    removeAnnonce(index) {
      this.$emit('removeAnnonce',index)
    },

    editAnnonce(event, index) {
      if([...event.srcElement.classList].includes('editAnnonce-forbidden')) {
        return
      }
      this.$emit('editAnnonce',index)
    },

    formatAnnonceInfo(annonce) {
      let parts = [];
      if (annonce.licensePlate && annonce.licensePlate.value !== null) parts.push(annonce.licensePlate.value);
      if (annonce.vin && annonce.vin.value !== null) parts.push(annonce.vin.value);
      if (annonce.bicycode && annonce.bicycode.value !== null) parts.push(annonce.bicycode.value);
      if (annonce.serialNumber && annonce.serialNumber.value !== null) parts.push(annonce.serialNumber.value);

      return parts.join(' | ');
    },

    addNewAnnonce(creationType){
      this.$emit('addNewAnnonce',creationType)
    },

    addDraft(annonce){
      this.$emit('addDraft',annonce)
    },

    backToAddAnnonce() {
      this.$bvModal.show('recap-add-annonce')
      this.$bvModal.hide('recap-add-brouillon-modal')
    },

    openBrouillonModal(){
      this.$bvModal.hide('recap-add-annonce')
      this.$bvModal.show('recap-add-brouillon-modal')
    },

    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },
  }
};
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-step-right-part {
    margin-top: -120px !important;
    height: calc(100% + 120px);
    overflow: auto;
  }
  #annonce-create-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.item-annonce{
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  border-radius: 10px;
  background-color: var(--main-black-medium);
  padding: 0.5rem;
  border: 1px solid var(--main-black-medium);
  margin-bottom: 5px;
}

.custom-plus{
  font-size: 48px;
}

.item-annonce:hover,
.item-active{
  cursor:pointer;
  border-color:var(--main-yellow-medium)!important;
}

.item-container-annonce{
  display: flex;
  flex-wrap: wrap;
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  gap: 2em;
}



</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateRecapStep.vue